<app-load-nav [activeMenuItem]="'btl'"></app-load-nav>


<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab>
    <ng-template mat-tab-label>
      <app-badge-with-loading [isLoading]="isTransactionsLoading" badgeColor="accent" [badgeHidden]="!dataSourceTransactions || dataSourceTransactions.length == 0" [badgeText]="dataSourceTransactions?.length?.toString()" title="Unlinked Transactions"></app-badge-with-loading>
    </ng-template>


    <mat-card class="content-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxFlex="70" style="vertical-align: text-top">
          <h4 style="vertical-align: text-top">Unlinked Transactions <span [matBadgeHidden]="!dataSourceTransactions || dataSourceTransactions.length === 0" matBadgeColor="warn" matBadge="{{dataSourceTransactions.length}}" matBadgeOverlap="false"></span></h4>
        </div>
        <div fxFlex="30" class="text-right">
          <ng-container *ngIf="!isBusy">

            <ng-container *ngIf="uploadOpened">
            <div class="text-left" style="margin-left: auto; height: 200px; width: 400px; background-color: lightgray; border-radius: 5px; padding: 10px;">
              <div class="text-center">
              Upload Commerzbank statement:
              </div>

              <app-file-upload *appHasRoles="['admin', 'manager', 'compliance']" (upload)="onUploadImportCsv($event,'commerzbank')"></app-file-upload>
              <div style="height: 20px;"></div>
              <button mat-raised-button color="primary" (click)="goToApproval()">Go to Approval</button>
              <button mat-raised-button style="margin-left: 5px;" (click)="uploadOpened = false;">Abort</button>
            </div>
            </ng-container>

            <button *ngIf="!uploadOpened" mat-raised-button color="primary" (click)="uploadOpened = true">Upload Statement</button>



          </ng-container>
          <ng-container *ngIf="isBusy">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>
        </div>

      </mat-card-header>
      <app-mat-table-generator #table
                               [saveFilters]=true
                               tableName="trustPayTransactionTable"
                               [useEmbededFilter]="true"
                               [columns]="columnsTransactions"
                               [dataSource]="dataSourceTransactions"
                               [editEnabled]="editEnabled()"
                               [deleteEnabled]="deleteTransactionsEnabled()"
                               [multiselectEnabled]="false"
                               [customActions]="transCustomactions"
                               [rowClassCallback]="getRowClassTransaction"
                               [viewLink]="getViewLinkTransaction"
                               [editLink]="getEditLinkTransaction"
                               [defaultSortField] = "'createDate'"
                               [defaultSortDirection]="'desc'"
      >
      </app-mat-table-generator>
    </mat-card>


  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <app-badge-with-loading [isLoading]="isPendingLoading" badgeColor="primary" [badgeHidden]="!dataSourcePending || dataSourcePending.length == 0" [badgeText]="dataSourcePending?.length?.toString()" title="Pending Loads"></app-badge-with-loading>
    </ng-template>

    <mat-card class="content-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxFlex="40">
          <h4>Pending Bank Transfer Loads</h4>
        </div>
        <div fxFlex="60" class="text-right">

          <button style="margin-right: 10px;" mat-raised-button color="" [disabled]="isBusy || isLoading || isImporting" (click)="goToLoadRefundList()">Load refunds</button>

          <button style="margin-right: 10px;" mat-raised-button color="" [disabled]="isBusy || isLoading || isImporting" (click)="goToLastLoadFiles()">Last load files</button>
          <button style="margin-left: 15px; margin-right: 40px;" mat-raised-button color="" [hidden]="!currentUserIsAdmin() && !currentUserIsFinanceManager()" [disabled]="isBusy || isLoading || isImporting" (click)="gotToGpsHistory()">Load History</button>

          <button mat-raised-button color="primary" [disabled]="true" (click)="downloadLoads()">Download Load File</button>

          <button style="margin-left: 50px;" mat-raised-button color="blue" [disabled]="true" (click)="uploadGpsLoadResponse()">Upload GPS Response File</button>



        </div>

      </mat-card-header>

      <app-mat-table-generator #tablePending
                               [saveFilters]=true
                               tableName="bankTransferLoadTable"
                               [useEmbededFilter]="true"
                               [columns]="columns"
                               [dataSource]="dataSourcePending"
                               [editEnabled]="editEnabled()"
                               [deleteEnabled]="deleteLoadsEnabled()"
                               [multiselectEnabled]="false"
                               [customActions]=""
                               [rowClassCallback]="getRowClass"
                               [viewLink]="getViewLink"
                               [editLink]="getEditLink"
                               [customQueryParams]="{f: 'pending'}"
                               [defaultSortField] = "'createDate'"
                               [defaultSortDirection]="'desc'"
      >
      </app-mat-table-generator>

    </mat-card>

  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <app-badge-with-loading [isLoading]="isPreApprovedLoading" badgeColor="accent"  [badgeHidden]="!dataSourcePreApproved || dataSourcePreApproved.length === 0" [badgeText]="dataSourcePreApproved?.length?.toString()" title="4-Eyes"></app-badge-with-loading>
    </ng-template>

    <mat-card class="content-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxFlex="100">
          <h4>Bank Transfer Loads needing second approval</h4>
        </div>

      </mat-card-header>

      <app-mat-table-generator #tablePreApproved
                               [saveFilters]=true
                               tableName="bankTransferLoadPreApprovedTable"
                               [useEmbededFilter]="true"
                               [columns]="columns"
                               [dataSource]="dataSourcePreApproved"
                               [editEnabled]="editEnabled()"
                               [deleteEnabled]="deleteLoadsEnabled()"
                               [multiselectEnabled]="false"
                               [customActions]=""
                               [rowClassCallback]="getRowClass"
                               [customQueryParams]="{f: 'pre-approved'}"
                               [viewLink]="getViewLink"
                               [editLink]="getEditLink"
                               [defaultSortField] = "'createDate'"
                               [defaultSortDirection]="'desc'"
      >
      </app-mat-table-generator>

    </mat-card>

  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <app-badge-with-loading [isLoading]="isDelayedLoading" badgeColor="accent"  [badgeHidden]="!dataSourceDelayed || dataSourceDelayed.length === 0" [badgeText]="dataSourceDelayed?.length?.toString()" title="Delayed"></app-badge-with-loading>
    </ng-template>

    <mat-card class="content-card">
      <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxFlex="100">
          <h4>Bank Transfer Loads that are delayed</h4>
        </div>

      </mat-card-header>

      <app-mat-table-generator #tableDelayed
                               [saveFilters]=true
                               tableName="bankTransferLoadDelayedTable"
                               [useEmbededFilter]="true"
                               [columns]="columns"
                               [dataSource]="dataSourceDelayed"
                               [editEnabled]="editEnabled()"
                               [deleteEnabled]="deleteLoadsEnabled()"
                               [multiselectEnabled]="false"
                               [customActions]=""
                               [rowClassCallback]="getRowClass"
                               [customQueryParams]="{f: 'delayed'}"
                               [viewLink]="getViewLink"
                               [editLink]="getEditLink"
                               [defaultSortField] = "'createDate'"
                               [defaultSortDirection]="'desc'"
      >
      </app-mat-table-generator>

    </mat-card>

  </mat-tab>

</mat-tab-group>





